import { Component, OnInit, Input } from '@angular/core';
import { TdMediaService } from '@covalent/core/media';
import { Router, ActivatedRoute, NavigationEnd, GuardsCheckEnd, NavigationCancel } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { TitleService } from '../services/title.service';
import { BusyService } from '../../services/busy.service';

@Component({
  selector: 'stp-layout-nav-list',
  templateUrl: './layout-nav-list.component.html',
  styleUrls: ['./layout-nav-list.component.scss']
})
export class LayoutNavListComponent implements OnInit {
  @Input() appName: string;
  @Input() versionInfo: string;
  @Input() menu: Object[];

  constructor(public media: TdMediaService,
    public titleService: TitleService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public busyService: BusyService) { }

  ngOnInit() {
    this.titleService.setAppName(this.appName);
    this.busyService.stopFullPage();

    this.updateTitleOnRouteChange();
    this.spinnerOnRouteChange();
  }

  private updateTitleOnRouteChange() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data)
      )
      .subscribe((event) => {
        this.titleService.setPageTitle(event['title']);
      });
  }

  private spinnerOnRouteChange() {
    this.router.events
      .subscribe(event => {
      if (event instanceof GuardsCheckEnd) {
        this.busyService.startFullPage();
      }
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        this.busyService.stopFullPage();
      }
    });
  }
}
